import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import { AnimatePresence, motion } from "framer-motion";
import CardWithNumber from "../generic/CardWithNumber";

const TrackCompareGrow = () => {
  const howItWorksItems = [
    {
      number: 1,
      title: "Create and Group Links",
      subtitle: "Organize links by campaigns or users for better tracking.",
      description:
        "Group links based on campaigns or user types to streamline tracking and analysis.",
    },

    {
      number: 2,
      title: "View and Compare Metrics",
      subtitle: "Analyze key metrics across platforms and time ranges.",
      description:
        "Track installs, opens, time in app, and more with customizable filters to compare performance.",
    },
    {
      number: 3,
      title: "Identify Top Performers",
      subtitle: "Find which links and users drive the most value.",
      description:
        "Spot high-performing links and users to scale your efforts effectively.",
    },
  ];
  return (
    <FullPageContainer>
      <Container id={"trackCompareGrow"}>
        <Line>
          <TextWrapper>
            <Title>Track, Compare, and Grow with Confidence</Title>
            <Subtitle>
              Easily integrate your ad platforms, gain complete visibility into
              user journeys across channels, and focus your budget on the
              campaigns that deliver real results—no more guesswork, just
              smarter growth.
            </Subtitle>
          </TextWrapper>
        </Line>
        <ItemsWrapper>
          {howItWorksItems.map((item, index) => (
            <CardWithNumber
              key={index}
              title={item.title}
              subtitle={item.subtitle}
              description={item.description}
              number={item.number}
            />
          ))}
        </ItemsWrapper>
      </Container>
    </FullPageContainer>
  );
};

export default TrackCompareGrow;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.darkColor};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
padding:100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;

const Title = styled.h1`
  color: ${lightThemeColors.lightColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  text-align: center;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const Subtitle = styled.p`
  color: ${lightThemeColors.lightColorFaded7};
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
  @media (max-width: 990px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 30px;
  max-width: 850px;
  margin: auto;
  @media (max-width: 990px) {
    max-width: unset;
  }
`;

const Line = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 25px;
  @media (max-width: 990px) {
    gap: 30px;
    flex-direction: column;
  }
`;
const ItemsWrapper = styled(motion.div)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 40px;
  width: 100%;

  & > * {
    max-width: 600px;
    width: 100%;
  }

  @media (max-width: 990px) {
    flex-direction: column;
    align-items: center;
    width:100%;
    flex-wrap:unset;
    & > * {
      width: 100%;

    }
  }
`;
